import Config from "./ConfigUrl";

var config = new Config();
var baseUrl = config.apiUrl;

class ApiService {

  getToken = () => localStorage.getItem("workflow_token");

  getHeaders = (extraHeaders = {}) => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${this.getToken()}`,
    ...extraHeaders
  });

  getData = async (path, queryParams) => {
    try {
      const url = new URL(`${baseUrl}${path}`);
      Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));
      var response = await fetch(url, {
        method: 'GET',
        headers: this.getHeaders(),
      });
      if (response.status === 200) {
        return response;
      } else {
        return {
          "Success": false
        };
      }
    } catch (e) {
      console.log(e);
    }
  };

  postData = async (path, queryParams, requestBody) => {
    try {
      const url = new URL(`${baseUrl}${path}`);
      Object.keys(queryParams).forEach(key => url.searchParams.append(key, queryParams[key]));
      const response = await fetch(url, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(requestBody)
      });
      if (typeof response === "string") {
        const result = response;
        return result;
      }
      else {
        if (response.status === 200) {
          const result = await response.json();
          return result;
        }
        else {
          return {
            "Success": false
          };
        }
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  postDataSelected = async (path, queryParams = {}, requestBody = []) => {
    try {
      const url = new URL(`${baseUrl}${path}`);

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          url.searchParams.append(key, value);
        }
      });

      const response = await fetch(url.toString(), {
        method: "POST",
        headers: this.getHeaders({
          Accept: "application/json"
        }),
        body: JSON.stringify(requestBody), // MUST be an array
      });
      if (!response.ok) {
        const error = await response.json().catch(() => null);
        console.error("API error:", response.status, error);
        return {
          success: false,
          status: response.status,
          error
        };
      }

      const result = await response.json();
      return result;

    } catch (error) {
      console.error("Fetch error:", error);
      return {
        success: false,
        error: error.message
      };
    }
  };
}
export default ApiService;
